module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "eeepGreekBig.0332be4f.webp";